import { PartsType, RealtimeData } from "../types/types";
import jQuery from "jquery";

export const addToCartShopify = (variantIdLong: string | undefined, quantity: string, part: PartsType | undefined, realtimeData: RealtimeData | undefined) => {
  if (variantIdLong) {
    let variantIdShort = variantIdLong.split("gid://shopify/ProductVariant/")[1];
    if (variantIdShort === undefined) {
      variantIdShort = variantIdLong; // todo luci fix this
    }

    // @ts-ignore
    const shopifyGlobal = window.parent.Shopify;

    fetch(shopifyGlobal.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        items: [
          {
            id: variantIdShort,
            quantity: quantity || "1",
          },
        ],
      }),
    })
      .then((response) => {
        jQuery.getJSON("/cart.js", function (cart) {
          const shop = shopifyGlobal.shop;

          if (shop.includes("nuts-2132.myshopify.com")) {
            handleMotoExperienceAddToCart(cart);
          } else if (shop.includes("wmr2.myshopify.com")) {
            handleWmr2(cart);
          } else if (shop.includes("allsupermotoas.myshopify.com")) {
            handleMotoExperienceAddToCart(cart);
          } else {
            handleAddToCartGeneric(cart);
          }
        });

        return response.json();
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  if (!part && !realtimeData) {
    console.log("No part or realtimeData. Cannot add to cart");
    return;
  }
};

function handleWmr2(cart: any) {
  const itemCount = cart.item_count;
  jQuery(".count-bubble").text(itemCount).css("opacity", 1);

  // Prevent navigation and trigger native click
  jQuery("a[href='/cart'].relative.tap-area")
    .on("click", function (e) {
      e.preventDefault(); // Stop navigation to /cart
    })[0]
    .click();

  // Explicitly open cart drawer
  jQuery("#cart-drawer")
    .addClass("is-open cart--open") // Common classes for Shopify drawers
    .attr("aria-hidden", "false")
    .css({ opacity: 1, display: "block" }); // Ensure visibility

  // Update ARIA attributes on the link
  jQuery("a[href='/cart'].relative.tap-area").attr("aria-expanded", "true");

  jQuery(document.body).trigger("added_to_cart"); // Trigger Shopify cart update

  const cartCount = cart.item_count || 0;
  jQuery(".count-bubble")
    .text(cartCount)
    .attr("aria-hidden", cartCount === 0 ? "true" : "false")
    .css("opacity", cartCount === 0 ? 0 : 1);

  // Dispatch Shopify theme events to refresh cart drawer
  document.dispatchEvent(new CustomEvent("cart:build", { bubbles: true }));
  document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true, detail: cart }));
}

function handleAddToCartGeneric(cart: any) {
  console.log("lucitest handle generic");
  if (jQuery("div.cart-count-bubble").length == 0) {
    jQuery(
      '<div class="cart-count-bubble"><span aria-hidden="true">' + cart.item_count + '</span><span class="visually-hidden">3 artikelen</span></div>'
    ).insertAfter("span.visually-hidden");
  } else {
    jQuery(" div.cart-count-bubble > span").html(cart.item_count);
  }

  jQuery("div#cart-notification").addClass("active animate");
  jQuery("a#cart-notification-button").html("View Cart (" + cart.item_count + ")");

  jQuery("#spinner_loading").remove();

  document.dispatchEvent(new CustomEvent("dispatch:cart-drawer:refresh", { bubbles: true, detail: cart }));
  // Dispatch Shopify theme events to refresh cart drawer
  document.dispatchEvent(new CustomEvent("cart:build", { bubbles: true }));
  document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true, detail: cart }));
}

function handleMotoExperienceAddToCart(cart: any) {
  console.log("lucitest motoexperience", cart);
  // update cart counter
  const htmlinner = `<div class="header__cart-count absolute bg-theme-text text-theme-bg text-center"><span aria-hidden="true">${cart.item_count}</span><span class="visually-hidden">1 produs</span></div>`;

  const cartIconBubble = document?.querySelector("#cart-icon-bubble");

  if (cartIconBubble) {
    cartIconBubble.innerHTML = htmlinner;
  }

  // @ts-ignore
  document?.querySelector("cart-drawer")?.open();

  document.dispatchEvent(new CustomEvent("dispatch:cart-drawer:refresh", { bubbles: true, detail: cart }));
}
